export default __webpack_public_path__ + "static/media/15024.36c52a55.png";